import React from 'react';
import { useLocation } from 'react-router';

const withRouteInformation = (WrappedComponent: any) => {
	const WithRouteInformation = (props: any) => {
		const location = useLocation();

		return <WrappedComponent {...props} pathname={location.pathname} />;
	};

	return WithRouteInformation;
};

export default withRouteInformation;
